import { useEffect } from "react";
import { MessageCircle } from "lucide-react";
import { useSite } from "@/lib/SiteContext";
import { buildWhatsAppUrl } from "@/lib/constants";
import { trackWaClick } from "@/lib/track";

export const FloatingWhatsApp = () => {
  const { locale } = useSite();
  useEffect(() => {}, []);
  return (
    <a
      href={buildWhatsAppUrl()}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => trackWaClick("floating_button")}
      className="fixed bottom-5 right-5 z-40 flex items-center gap-2 px-4 py-3 rounded-full transition-transform hover:-translate-y-1"
      style={{
        background: "linear-gradient(135deg, #FF1F8F 0%, #FCB424 50%, #8AE52E 100%)",
        color: "#0B0E1E",
        boxShadow: "0 18px 40px -16px rgba(255,31,143,0.55)",
        fontWeight: 600,
      }}
      data-testid="floating-whatsapp"
      aria-label="WhatsApp"
    >
      <MessageCircle size={18} strokeWidth={2} />
      <span className="text-[0.84rem] tracking-wide hidden sm:inline">
        {locale === "es" ? "Hablar" : "Chat"}
      </span>
    </a>
  );
};

export default FloatingWhatsApp;
